import ProductMaterial from '@/models/ProductMaterial';

export default class ProductMaterialRepository {
    public static getAll() {
        return ProductMaterial.query().withAllRecursive().get();
    }
}
